export default __webpack_public_path__ + "static/media/icon_toast_close.402ffe76.svg";